var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgEdit = function SvgSvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.748 24a.755.755 0 0 1-.53-.22.754.754 0 0 1-.197-.716l1.77-6.905a.84.84 0 0 1 .045-.121.73.73 0 0 1 .151-.223L16.513 1.289A4.355 4.355 0 0 1 19.611 0c1.178 0 2.277.454 3.106 1.279l.03.029a4.367 4.367 0 0 1 1.25 3.121 4.356 4.356 0 0 1-1.32 3.087L8.183 22.01a.735.735 0 0 1-.23.154.784.784 0 0 1-.112.042L.933 23.978A.773.773 0 0 1 .748 24Zm1.041-1.791 4.41-1.131-3.28-3.275-1.13 4.406Zm5.868-1.795 13.02-13.02-4.074-4.074L3.58 16.344l4.077 4.07Zm14.08-14.082a2.893 2.893 0 0 0-.06-3.972l-.02-.02a2.872 2.872 0 0 0-2.037-.84v-.375.375a2.873 2.873 0 0 0-1.955.762l4.071 4.07Z",
    fill: "currentColor"
  })));
};
export default SvgSvgEdit;